import { Component, Inject, Injector } from "@angular/core";
import { Params, Router } from "@angular/router";
import { AUC_ICONS_CONFIG_TOKEN, AucIconsConfig } from "@auction-ui/config";
import { MfActionCardAction, MfActionCardActions, MfBaseComponent, mfStringIsEmptyOrWhitespace, MfTableQueryFilterService, MfTypeInfo } from "@pattonair/material-framework";
import { AucFeatureService } from "../services/feature.service";
import { AucSideMenuService } from "../services/side.menu.service";


const TYPE_INFO: MfTypeInfo = { className: "AucHomeComponent" };

export type AucActionCardAction = MfActionCardAction & {
  redirectUrl?: string;
  queryParams?: Params;
};

export type AucActionCardActions = MfActionCardActions & {
  cards: AucActionCardAction[];
};

@Component({
  selector: "ecom-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class AucHomeComponent extends MfBaseComponent {
  protected _actions?: AucActionCardActions;

  public constructor(
    protected override _injector: Injector,
    protected _router: Router,
    protected _tableQueryFilterService: MfTableQueryFilterService,
    protected _featureService: AucFeatureService,
    protected _sideMenuService: AucSideMenuService,
    @Inject(AUC_ICONS_CONFIG_TOKEN)
    protected _config: AucIconsConfig,
  ) {
    super(TYPE_INFO, _injector);
    this._onFeaturesChange();
  }

  protected _actionClicked(action: AucActionCardAction): void {
    if (!mfStringIsEmptyOrWhitespace(action.redirectUrl)) {
      this._router.navigate([action.redirectUrl], { queryParams: action.queryParams });
    }

  }

  protected _onFeaturesChange(): void {
    const actions: AucActionCardActions = {
      iconSize: 30,
      minWidth: 300,
      maxWidth: 300,
      cards: [],
    };
    actions.cards = this._sideMenuService.getActionCardActions([], this._config);
    this._actions = actions;
  }
}
